function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2.856,
  cy: 2.856,
  r: 2.856,
  transform: "translate(0.026 43.503)",
  fill: "#009632"
});

var _ref3 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2.856,
  cy: 2.856,
  r: 2.856,
  transform: "translate(50.278 14.501)",
  fill: "#009632"
});

var _ref4 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2.856,
  cy: 2.856,
  r: 2.856,
  transform: "translate(50.278 29.002)",
  fill: "#009632"
});

var _ref5 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2.856,
  cy: 2.856,
  r: 2.856,
  transform: "translate(25.281 14.501)",
  fill: "#009632"
});

var _ref6 =
/*#__PURE__*/
React.createElement("circle", {
  cx: 2.856,
  cy: 2.856,
  r: 2.856,
  transform: "translate(37.715 36.256)",
  fill: "#009632"
});

var _ref7 =
/*#__PURE__*/
React.createElement("path", {
  d: "M-22.3-210.5a2.766,2.766,0,0,0-.051-.519l7.966-4.6a2.894,2.894,0,0,0,4.083-.292A2.894,2.894,0,0,0-10.6-220a2.9,2.9,0,0,0-4.083.292,2.9,2.9,0,0,0-.656,2.437l-7.972,4.6a2.856,2.856,0,0,0-4.03.276,2.857,2.857,0,0,0,.276,4.03,2.864,2.864,0,0,0,.968.555v9.2a2.862,2.862,0,0,0-1.736,3.657,2.863,2.863,0,0,0,3.657,1.736,2.863,2.863,0,0,0,1.736-3.657,2.864,2.864,0,0,0-1.736-1.736v-9.2A2.856,2.856,0,0,0-22.3-210.5Z",
  transform: "translate(28.041 227.938)",
  fill: "#fff"
});

var _ref8 =
/*#__PURE__*/
React.createElement("path", {
  d: "M14.3-226.288a2.835,2.835,0,0,0,1.851-.692l7.972,4.585a2.766,2.766,0,0,0-.051.519,2.855,2.855,0,0,0,2.851,2.861,2.856,2.856,0,0,0,2.861-2.85,2.856,2.856,0,0,0-2.851-2.862,2.857,2.857,0,0,0-1.862.686L17.1-228.625a2.765,2.765,0,0,0,.051-.519A2.856,2.856,0,0,0,14.3-232a2.856,2.856,0,0,0-2.856,2.856,2.856,2.856,0,0,0,2.856,2.856Z",
  transform: "translate(13.841 232)",
  fill: "#fff"
});

var _ref9 =
/*#__PURE__*/
React.createElement("path", {
  d: "M46.651-163.69a2.856,2.856,0,0,0-2.856,2.856,2.765,2.765,0,0,0,.051.519l-7.972,4.6a2.849,2.849,0,0,0-4.016.328,2.85,2.85,0,0,0,.328,4.017A2.849,2.849,0,0,0,36.2-151.7a2.845,2.845,0,0,0,.677-1.845,2.834,2.834,0,0,0-.051-.525l7.966-4.6a2.856,2.856,0,0,0,4.027-.315A2.855,2.855,0,0,0,48.505-163,2.854,2.854,0,0,0,46.651-163.69Z",
  transform: "translate(6.534 207.113)",
  fill: "#fff"
});

var _ref10 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.2-145.014a2.837,2.837,0,0,0-1.857.692l-7.966-4.585a2.766,2.766,0,0,0,.051-.519A2.863,2.863,0,0,0-5.424-152.3,2.863,2.863,0,0,0-8.3-149.453a2.862,2.862,0,0,0,2.848,2.876,2.865,2.865,0,0,0,1.871-.684l7.972,4.6a2.766,2.766,0,0,0-.051.519A2.856,2.856,0,0,0,7.2-139.282a2.856,2.856,0,0,0,2.856-2.856A2.856,2.856,0,0,0,7.2-144.994h0Z",
  transform: "translate(20.941 203.018)",
  fill: "#fff"
});

var _ref11 =
/*#__PURE__*/
React.createElement("path", {
  d: "M7.2-175.976a2.869,2.869,0,0,0-1.857.685l-7.966-4.6a2.824,2.824,0,0,0-1.857-3.2v-9.215a2.855,2.855,0,0,0,1.729-3.65,2.855,2.855,0,0,0-3.65-1.729,2.855,2.855,0,0,0-1.729,3.65,2.858,2.858,0,0,0,1.729,1.729v9.208a2.849,2.849,0,0,0-1.726,3.642,2.85,2.85,0,0,0,3.642,1.726,2.844,2.844,0,0,0,.889-.514l7.992,4.63a2.766,2.766,0,0,0-.051.519A2.856,2.856,0,0,0,7.2-170.239a2.856,2.856,0,0,0,2.856-2.856A2.856,2.856,0,0,0,7.2-175.951h0Z",
  transform: "translate(20.941 219.527)",
  fill: "#fff"
});

var _ref12 =
/*#__PURE__*/
React.createElement("path", {
  d: "M25.067-192.854a2.894,2.894,0,0,0,4.083-.292,2.894,2.894,0,0,0-.292-4.083,2.9,2.9,0,0,0-4.083.292,2.9,2.9,0,0,0-.656,2.437l-7.972,4.6a2.856,2.856,0,0,0-4.026.325,2.856,2.856,0,0,0,.325,4.026,2.856,2.856,0,0,0,4.026-.325,2.854,2.854,0,0,0,.681-1.855,2.765,2.765,0,0,0-.051-.519Z",
  transform: "translate(13.841 219.612)",
  fill: "#fff"
});

var _ref13 =
/*#__PURE__*/
React.createElement("path", {
  d: "M85.44-178.03v-20.19H98.4v3.112H89.109v4.982h8.273v3.061H89.109v5.917h10v3.118Z",
  transform: "translate(-13.161 219.694)",
  fill: "#fff"
});

var _ref14 =
/*#__PURE__*/
React.createElement("path", {
  d: "M119.313-185.822l3.24-4.668h3.7l-5.123,7.3q1.6,2.01,3.074,4.066a33.812,33.812,0,0,1,2.421,3.874h-3.842a10.589,10.589,0,0,0-.685-1.178c-.282-.429-.576-.877-.9-1.338s-.64-.922-1-1.377-.685-.884-1.012-1.281a27.942,27.942,0,0,0-2,2.625c-.64.961-1.191,1.806-1.62,2.561H112a17.253,17.253,0,0,1,1.063-1.851c.416-.64.871-1.281,1.345-1.985s.98-1.351,1.486-2.03,1.012-1.319,1.511-1.921l-5.168-7.447h3.842Z",
  transform: "translate(-22.806 216.897)",
  fill: "#fff"
});

var _ref15 =
/*#__PURE__*/
React.createElement("path", {
  d: "M144.976-191.081a8.743,8.743,0,0,1,2.946.435,4.763,4.763,0,0,1,1.921,1.223,4.641,4.641,0,0,1,1.018,1.921,9.309,9.309,0,0,1,.307,2.465v9.221c-.544.115-1.364.256-2.465.423a24.852,24.852,0,0,1-3.714.25,11.27,11.27,0,0,1-2.5-.263,5.47,5.47,0,0,1-1.921-.845,4.025,4.025,0,0,1-1.281-1.518,5.25,5.25,0,0,1-.455-2.3,4.445,4.445,0,0,1,.512-2.216,4.177,4.177,0,0,1,1.383-1.473,6.022,6.022,0,0,1,2.056-.813,11.334,11.334,0,0,1,2.4-.25,10.379,10.379,0,0,1,1.229.077,10.826,10.826,0,0,1,1.364.243v-.583a4.583,4.583,0,0,0-.141-1.165,2.5,2.5,0,0,0-.512-.973,2.446,2.446,0,0,0-.961-.64,4.2,4.2,0,0,0-1.5-.231,13.481,13.481,0,0,0-2.248.173,10.563,10.563,0,0,0-1.658.41l-.467-2.882a14.557,14.557,0,0,1,1.921-.467A15.339,15.339,0,0,1,144.976-191.081Zm.295,13.14a13.2,13.2,0,0,0,2.472-.173v-3.906a6.8,6.8,0,0,0-.845-.173,7.9,7.9,0,0,0-1.223-.09,8.242,8.242,0,0,0-1.178.09,3.518,3.518,0,0,0-1.076.32,1.971,1.971,0,0,0-.775.64,1.84,1.84,0,0,0-.288,1.063,1.863,1.863,0,0,0,.788,1.735A4.035,4.035,0,0,0,145.271-177.942Z",
  transform: "translate(-32.54 217.111)",
  fill: "#fff"
});

var _ref16 =
/*#__PURE__*/
React.createElement("path", {
  d: "M166.38-190.179a24.242,24.242,0,0,1,2.657-.551,22.956,22.956,0,0,1,3.612-.263,8.322,8.322,0,0,1,3.118.512,4.823,4.823,0,0,1,1.991,1.4,5.369,5.369,0,0,1,1.05,2.209,12.307,12.307,0,0,1,.307,2.843v8.593h-3.528v-8.017a11.441,11.441,0,0,0-.16-2.081,3.615,3.615,0,0,0-.525-1.4,2.107,2.107,0,0,0-.986-.788,4.154,4.154,0,0,0-1.53-.25,11.943,11.943,0,0,0-1.4.09c-.48.058-.845.109-1.076.147v12.295H166.38Z",
  transform: "translate(-42.544 217.08)",
  fill: "#fff"
});

var _ref17 =
/*#__PURE__*/
React.createElement("path", {
  d: "M194.24-197.1l3.528-.583v4.6h5.417v2.946h-5.417v6.2a4.483,4.483,0,0,0,.583,2.619,2.3,2.3,0,0,0,1.979.788,6.5,6.5,0,0,0,1.7-.2,11.468,11.468,0,0,0,1.185-.378l.583,2.8a14.042,14.042,0,0,1-1.607.538,8.644,8.644,0,0,1-2.331.275,7.458,7.458,0,0,1-2.721-.435,4.016,4.016,0,0,1-1.735-1.281,5.044,5.044,0,0,1-.9-2.011,12.626,12.626,0,0,1-.263-2.7Z",
  transform: "translate(-52.646 219.497)",
  fill: "#fff"
});

var _ref18 =
/*#__PURE__*/
React.createElement("path", {
  d: "M213.6-183.018a9.6,9.6,0,0,1,.6-3.522,7.414,7.414,0,0,1,1.582-2.523,6.582,6.582,0,0,1,2.273-1.511,7.047,7.047,0,0,1,2.619-.512,6.288,6.288,0,0,1,4.911,1.921q1.755,1.921,1.761,5.827v.64a2.846,2.846,0,0,1-.045.64H217.243a4.035,4.035,0,0,0,1.281,2.843,4.913,4.913,0,0,0,3.336,1.005,11.127,11.127,0,0,0,2.344-.231,9.677,9.677,0,0,0,1.69-.429l.461,2.888a5.238,5.238,0,0,1-.8.3,11.044,11.044,0,0,1-1.165.295c-.435.09-.909.16-1.409.218a13.663,13.663,0,0,1-1.543.09,9.206,9.206,0,0,1-3.5-.6,6.517,6.517,0,0,1-2.453-1.659,6.769,6.769,0,0,1-1.422-2.5A10.152,10.152,0,0,1,213.6-183.018Zm10.246-1.569a4.729,4.729,0,0,0-.2-1.39,3.536,3.536,0,0,0-.6-1.133,2.869,2.869,0,0,0-.986-.724,3.024,3.024,0,0,0-1.351-.275,3.15,3.15,0,0,0-1.428.3,3.316,3.316,0,0,0-1.037.8,3.648,3.648,0,0,0-.64,1.14,6.22,6.22,0,0,0-.32,1.281Z",
  transform: "translate(-59.691 217.116)",
  fill: "#fff"
});

var _ref19 =
/*#__PURE__*/
React.createElement("path", {
  d: "M241.229-183.073a9.249,9.249,0,0,1,.525-3.157,7.427,7.427,0,0,1,1.5-2.561,6.86,6.86,0,0,1,2.376-1.691,7.825,7.825,0,0,1,3.144-.608,10.652,10.652,0,0,1,4.079.788l-.756,2.882a8.172,8.172,0,0,0-1.409-.41,7.523,7.523,0,0,0-1.646-.173,3.842,3.842,0,0,0-3.15,1.281,5.57,5.57,0,0,0-1.076,3.656,5.761,5.761,0,0,0,1.018,3.6,4.073,4.073,0,0,0,3.439,1.326,9.183,9.183,0,0,0,1.78-.173,8.015,8.015,0,0,0,1.511-.442l.493,2.914a6.991,6.991,0,0,1-1.761.525,12.127,12.127,0,0,1-2.433.237,8.735,8.735,0,0,1-3.394-.6,6.4,6.4,0,0,1-2.389-1.658,6.859,6.859,0,0,1-1.409-2.561A10.4,10.4,0,0,1,241.229-183.073Z",
  transform: "translate(-69.802 217.113)",
  fill: "#fff"
});

var _ref20 =
/*#__PURE__*/
React.createElement("path", {
  d: "M266-179.389v-22.028l3.528-.583v7.543a9.355,9.355,0,0,1,1.351-.346,8.34,8.34,0,0,1,1.524-.154,7.911,7.911,0,0,1,3.048.512,4.8,4.8,0,0,1,1.921,1.428,5.547,5.547,0,0,1,1.037,2.2,12.311,12.311,0,0,1,.3,2.856v8.574h-3.522v-8.017a11.44,11.44,0,0,0-.16-2.081,3.711,3.711,0,0,0-.525-1.4,2.141,2.141,0,0,0-.973-.788,4.046,4.046,0,0,0-1.518-.25,7.375,7.375,0,0,0-1.428.147,9.514,9.514,0,0,0-1.076.263v12.122Z",
  transform: "translate(-78.712 221.063)",
  fill: "#fff"
});

var SvgLogoExantech = function SvgLogoExantech(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    viewBox: "0 0 200 63.735",
    ref: svgRef
  }, props), _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgLogoExantech, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/logo-exantech.6c50ed21.svg";
export { ForwardRef as ReactComponent };